export default "<p>adminlayout works!</p>\r\n"